import React, { useEffect, useState } from "react";
import OwlCarousel from 'react-owl-carousel';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import '../assets/courseSlider/CourseTypeSlider.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const courseTypes = [
  'IELTS',
  'GRE',
  'GMAT',
  'MBA',
  'Engineering',
  'Medical',
  'Fashion Designing',
  'IELTS',
  'GRE',
  'GMAT',
  'MBA',
  'Engineering',
  'Medical',
  'Fashion Designing',
];

const CourseTypeSlider = ({ onSelectType }) => {
  const [testSeriesData1, settestSeriesData1] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state

  const fetchWallOfFame = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getExamPreparations`);
    
      settestSeriesData1(response.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWallOfFame();
  }, []); 
  const options = {
    loop: true,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 4,
      },
      1000: {
        items: 6,
      },
    },
  };

  return (
    <div className="course-slider-container">
      <OwlCarousel className="owl-theme" {...options}>
        {testSeriesData1.map((type, index) => (
          <div key={index}  onClick={() => onSelectType(type.exam_title)}>
            <div className="course-pill">{type.exam_title}</div>
          </div>
        ))}
      </OwlCarousel>
      
    </div>
  );
};

export default CourseTypeSlider;
